var _g, _g2, _g3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgStocklistChangeAmount = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  viewBox: "-2.4 -2.4 28.80 28.80",
  fill: "#000000",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  strokeWidth: 0
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:1.6799999999999997;}")), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "12 16.58 16.89 14.14 16.89 8.77 12 6.36 7.12 8.77 7.12 14.14 12 16.58"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-1",
  points: "7.12 8.76 7.13 8.76 12 11.16 12 16.58"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-1",
  points: "12 16.58 12 11.16 16.87 8.76 16.88 8.76"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-1",
  points: "16.88 8.76 16.87 8.76 12 11.16 7.13 8.76 7.12 8.76"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M18.18,3.21A10.75,10.75,0,0,1,12,22.75"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M5.82,20.79A10.75,10.75,0,0,1,12,1.25"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-1",
  points: "18.84 7.12 17.86 3.21 21.77 3.21"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-1",
  points: "5.16 16.89 6.14 20.79 2.23 20.79"
}))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStocklistChangeAmount, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/stocklist-change-amount.720a0dea.svg";
export { ForwardRef as ReactComponent };